// cspell:ignore grok

export enum AxAIGrokModel {
  Grok43 = 'grok-4.3',
  Grok43Latest = 'grok-4.3-latest',
  GrokLatest = 'grok-latest',
  Grok420Reasoning = 'grok-4.20-reasoning',
  Grok420Reasoning0309 = 'grok-4.20-0309-reasoning',
  Grok420NonReasoning = 'grok-4.20-non-reasoning',
  Grok420NonReasoning0309 = 'grok-4.20-0309-non-reasoning',
  Grok420MultiAgent = 'grok-4.20-multi-agent',
  Grok420MultiAgent0309 = 'grok-4.20-multi-agent-0309',
  Grok41FastReasoning = 'grok-4-1-fast-reasoning',
  Grok41FastNonReasoning = 'grok-4-1-fast-non-reasoning',
  GrokVoiceThinkFast = 'grok-voice-think-fast-1.0',
  GrokVoiceFast = 'grok-voice-fast-1.0',
  Grok3 = 'grok-3',
  Grok3Mini = 'grok-3-mini',
  Grok3Fast = 'grok-3-fast',
  Grok3MiniFast = 'grok-3-mini-fast',
}

export enum AxAIGrokEmbedModels {
  GrokEmbedSmall = 'grok-embed-small', // Placeholder, update if actual models are known
}
